<template>
    <div class="publication__donations content-width">
        <div class="publication__donations-row d-flex">
            <div class="publication__donations-item">
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">
                        Необходимая сумма( BYN)
                    </div>
                    <div class="publication__fieldset-input">
                        <input type="number" v-model="$v.need_sum.$model" placeholder="Введите сумму">
                    </div>
                    <div class="text-danger" v-if="!$v.need_sum.custom">Минимальное значение 0. </div>
                </div>
            </div>
            <div class="publication__donations-item">
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">
                        Текст благодарности спонсору (до 250 символов)
                    </div>
                    <div class="publication__fieldset-input">
                        <textarea v-model="thx_text" placeholder="Введите текст"></textarea>
                    </div>
                    <div class="text-danger" v-show="$v.thx_text.$error">Неверное значение.</div>
                </div>
            </div>
        </div>

        <div class="publication__section-row d-flex">

            <div class="publication__section-inner d-flex">
                <div class="publication__section-item">
                    <div class="publication__section-title">Включить возможность регулярных платежей</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="item in default_temp">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.allow_autopay.$model" :value="item.value">
                                <span class="circle"></span>
                                {{item.name}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.allow_autopay.$error">Неверное значение.</div>

                </div>
            </div>


        </div>

    </div>
</template>

<script>

const default_temp = [ { value: 1, name: 'Да' }, { value: 0, name: 'Нет' } ];

import { required, maxLength } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";
export default {
    name: "PublicationDonations",
    props: ['server'],
    mixins: [StateMixin],
    computed: {

        default_temp(){ return default_temp },

        allow_autopay: {
            get() { return this.GET_BY_KEY('allow_autopay') },
            set( val ) {
                this.SET_BY_KEY({key: 'allow_autopay', data:  val })
            }
        },

        need_sum: {
            get() { return this.GET_BY_KEY('need_sum') },
            set( val ) {
                this.SET_BY_KEY({key: 'need_sum', data:  val ? parseFloat(val) : null})
            }
        },

        thx_text: {
            get() { return this.GET_BY_KEY('thx_text') },
            set( val ) {
                this.SET_BY_KEY({key: 'thx_text', data: val})
            }
        },

    },



    methods: {

        isValid(){

            this.$v.$touch();
            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false

            }


            this.$emit('parent-update', true );
            return true

        }
    },

    validations:{
        need_sum: {
            required,
            custom(value){
                return parseFloat(value) >= 0
            }
        },
        allow_autopay: { required },
        thx_text:    { maxLength: maxLength(250) }
    }

}
</script>

<style scoped>

</style>
